
import { apiCall, ApiResponse } from "./apiClient";
import { VehicleMaintenanceDto } from "../models/vehicle/vehicleMaintenance";

export const saveVehicleMaintenance = async (
    vehicleMaintenance: VehicleMaintenanceDto,
    signal?: AbortSignal): Promise<ApiResponse<VehicleMaintenanceDto>> => {

    const isNew = !vehicleMaintenance.id ? true : false;

    return apiCall<VehicleMaintenanceDto>(
        "vehiclemaintenance",
        isNew ? "PUT" : "POST",
        vehicleMaintenance,
        signal);
};

export const deleteVehicleMaintenance = async (
    vehicleMaintenanceId: string,
    signal?: AbortSignal): Promise<ApiResponse<void>> => {

    return apiCall<void>(
        `vehiclemaintenance/${vehicleMaintenanceId}`,
        "DELETE",
        undefined,
        signal);
};

export const getVehicleMaintenances = async (
    fromDate: Date,
    untilDate?: Date,
    vehicleIds?: string[],
    signal?: AbortSignal) => {

    const response = await apiCall<VehicleMaintenanceDto[]>("vehiclemaintenance?fromDate=" + fromDate.toISOString() + (untilDate ? "&untilDate=" + untilDate.toISOString() : "") + (vehicleIds ? "&vehicleIds=" + vehicleIds.join(",") : ""), "GET", signal);
    return response.data;
};
